import type {
  MetaResponseModel,
  AutocompleteResponseModel,
} from '@searchspring/snapi-types'

import BaseSearchSpringController from '../base_searchspring_controller'
import { SearchspringUiRenderer } from '../../helpers/searchspring_ui_renderer'
import { SearchspringProduct } from '../../types/searchspring'

export default class SearchPageController extends BaseSearchSpringController {
  static targets = ['results']

  declare readonly resultsTarget: HTMLElement
  declare readonly hasResultsTarget: boolean

  connect() {
    super.connect()

    const params = new URLSearchParams(window.location.search)
    const query = params.get('q')

    if (query) {
      this.fetchSearch(query)
    }
  }

  async fetchSearch(query: string): Promise<void> {
    if (!this.hasResultsTarget) {
      console.warn('[SearchPage] no resultsTarget found')
      return
    }

    try {
      const [, autocomplete]: [MetaResponseModel, AutocompleteResponseModel] =
        await this.client.autocomplete({
          search: {
            query: { string: query, spellCorrection: true },
          },
        })

      const items = autocomplete.results ?? []
      const validItems = items.filter(
        (item): item is (typeof items)[number] & { id: string } =>
          item.id !== undefined,
      )

      if (validItems.length === 0) {
        this.resultsTarget.innerHTML = `<p>No results found.</p>`
        return
      }

      this.resultsTarget.innerHTML = SearchspringUiRenderer.renderProducts(
        validItems as unknown as SearchspringProduct[],
      )
    } catch {
      this.resultsTarget.innerHTML = `<p>No results found.</p>`
    }
  }
}
